import React from 'react'
import Card from '../components/Card';
import { useEffect } from 'react';
import {useSelector, useDispatch } from 'react-redux';
import { getProducts } from '../redux/product/thunk';
import Herobanner from '../components/Herobanner';

const Product = () => {

  const dispatch = useDispatch();
  const product = useSelector(state => state.products.data)
  useEffect(() => {
    dispatch(getProducts());
  }, [])


  return (
    <>
      <Herobanner/>
    
    <div className='m-auto container'>
    <div className='flex text-neutral-600 flex-wrap'>
    {product.map((product) => {
      //console.log(product.rating.rate)
        return(
        <Card 
        key={product.id}
            category={product.category}
            description={product.description}
            id={product.id}
            image={product.image}
            price={product.price}
            rating={product.rating.rate}
            title={product.title}
          />

          
        );
    })}
        
    </div></div>
    </>
  )
}

export default Product;